import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import DentalScheduleDefinition from '../components/DentalSchedule/ServiceSchedule';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    business: state.business,
    schedules: state.schedules,
    conversations: state.conversations,
    conversationDetails: state.conversationDetails,
    softwares: state.softwares,
    auth: state.auth,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DentalScheduleDefinition);
